'use client'

import { OtpSessionResponse, useOtpLogin } from '@/hooks/useOtpLogin'
import { useState } from 'react'
import OtpRequest from './OtpRequest'
import OtpVerify from './OtpVerify'

type Step = 'request' | 'verify'

export interface OtpLoginSuccessDetails {
  authToken: string
  userId: string
  email: string
  roles: string[]
  mobileVerified: boolean
  termsAccepted: boolean
}

interface OtpLoginProps {
  onBackToLogin: () => void
  onOtpLoginComplete?: (details: OtpLoginSuccessDetails) => void
  cartToken?: string
}

export default function OtpLogin({
  onBackToLogin,
  onOtpLoginComplete,
  cartToken,
}: OtpLoginProps) {
  const [step, setStep] = useState<Step>('request')
  const [otpEmail, setOtpEmail] = useState('')
  const {
    requesting,
    verifying,
    requestError,
    verifyError,
    requestOtp,
    verifyOtp,
    clearErrors,
  } = useOtpLogin()

  const handleVerifySuccess = (response: OtpSessionResponse) => {
    onOtpLoginComplete?.({
      authToken: response.auth_token,
      userId: response.id,
      email: response.email,
      roles: response.roles,
      mobileVerified: response.mobile_verified,
      termsAccepted: response.terms,
    })
  }

  if (step === 'verify') {
    return (
      <OtpVerify
        email={otpEmail}
        onBack={() => {
          clearErrors()
          setStep('request')
        }}
        onSuccess={handleVerifySuccess}
        onResend={() => {
          clearErrors()
          requestOtp(otpEmail)
        }}
        verifying={verifying}
        requesting={requesting}
        verifyError={verifyError}
        requestError={requestError}
        verifyOtp={verifyOtp}
        cartToken={cartToken}
      />
    )
  }

  return (
    <OtpRequest
      onCancel={() => {
        clearErrors()
        onBackToLogin()
      }}
      onSuccess={(email) => {
        setOtpEmail(email)
        setStep('verify')
      }}
      requesting={requesting}
      requestError={requestError}
      requestOtp={requestOtp}
    />
  )
}
